import { createRoute } from '@/utils/routing'

export const CURRENCY_LIST_ROUTE = 'channel-setup-license'
export const CHANNEL_EDIT_ROUTE = 'channel-setup-channel-route-channelRouteId-edit'
export const CHANNEL_CREATE_ROUTE = 'channel-setup-license-create'
export const CHANNEL_VIEW_ROUTE = 'channel-setup-channel-route-channelRouteId'
export const CHANNEL_SETTINGS_ROUTE = 'channel-setup-license-currency-index-settings'
export const CHANNEL_ACTIVITY_ROUTE = 'channel-setup-license-currency-index-activity'

export function createChannelRoutesCurrencyListRoute (license = 'GB', options = {}) {
  return createRoute(CURRENCY_LIST_ROUTE, { ...options, params: { ...options.params, license } })
}

export function createChannelRoutesSettingsRoute (license, currency, options = {}) {
  return createRoute(CHANNEL_SETTINGS_ROUTE, { ...options, params: { ...options.params, license, currency } })
}

export function createChannelRoutesActivityRoute (license, currency, options = {}) {
  return createRoute(CHANNEL_ACTIVITY_ROUTE, { ...options, params: { ...options.params, license, currency } })
}

export function createEditChannelRoute (channelRouteId, options = {}) {
  return createRoute(CHANNEL_EDIT_ROUTE, { ...options, params: { ...options.params, channelRouteId } })
}

export function createNewChannelRoute (license, options = {}) {
  return createRoute(CHANNEL_CREATE_ROUTE, { ...options, params: { ...options.params, license } })
}

export function createViewChannelRoute (channelRouteId, options = {}) {
  return createRoute(CHANNEL_VIEW_ROUTE, { ...options, params: { ...options.params, channelRouteId } })
}
